import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";

function Story(props) {
  const [completedProjects, setCompletedProjects] = useState(0);
  const [inHouseEngineers, setInHouseEngineers] = useState(0);
  const [industriesServed, setIndustriesServed] = useState(0);
  const [clutchReviews, setClutchReviews] = useState(0);

  const targetCompletedProjects = 100;
  const targetInHouseEngineers = 300;
  const targetIndustriesServed = 20;
  const targetClutchReviews = 65;

  useEffect(() => {
    const completedProjectsInterval = setInterval(() => {
      setCompletedProjects((prevCount) => {
        if (prevCount >= targetCompletedProjects) {
          clearInterval(completedProjectsInterval);
          return targetCompletedProjects;
        }
        return prevCount + 1;
      });
    }, 30);

    return () => clearInterval(completedProjectsInterval);
  }, [targetCompletedProjects]);

  useEffect(() => {
    const inHouseEngineersInterval = setInterval(() => {
      setInHouseEngineers((prevCount) => {
        if (prevCount >= targetInHouseEngineers) {
          clearInterval(inHouseEngineersInterval);
          return targetInHouseEngineers;
        }
        return prevCount + 1;
      });
    }, 40);

    return () => clearInterval(inHouseEngineersInterval);
  }, [targetInHouseEngineers]);

  useEffect(() => {
    const industriesServedInterval = setInterval(() => {
      setIndustriesServed((prevCount) => {
        if (prevCount >= targetIndustriesServed) {
          clearInterval(industriesServedInterval);
          return targetIndustriesServed;
        }
        return prevCount + 1;
      });
    }, 50);

    return () => clearInterval(industriesServedInterval);
  }, [targetIndustriesServed]);

  useEffect(() => {
    const clutchReviewsInterval = setInterval(() => {
      setClutchReviews((prevCount) => {
        if (prevCount >= targetClutchReviews) {
          clearInterval(clutchReviewsInterval);
          return targetClutchReviews;
        }
        return prevCount + 1;
      });
    }, 60);

    return () => clearInterval(clutchReviewsInterval);
  }, [targetClutchReviews]);

  return (
    <div className="tekrevol_story tekrevol_gray_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="example" data-text="Our Story">
              <h2>
                In Pursuit Of Scaling The Digital Ecosystem Through Top-Tier
                Product Teams
              </h2>
            </div>
            <div>
              <h4>OUR STORY</h4>
              <p>
                TekRevol came into existence after two tech enthusiasts from
                different backgrounds joined forces to create something bound to
                become a difference-maker in the digital world.
              </p>
              <p>
                The company started in 2018 as a mobile app development company
                but has since grown into a full-stack digital transformation
                organization offering enterprise software development and
                technical consultancy services for businesses worldwide.
              </p>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <ul>
              <li>
                {completedProjects}+<p>Successfully completed projects</p>
              </li>
              <li>
                {inHouseEngineers}+<p>In-house engineers</p>
              </li>
              <li>
                {industriesServed}+<p>Industries Served</p>
              </li>
              <li>
                {clutchReviews}+<p>Clutch Reviews</p>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Story;
